export const AOSMITH_LINKS = [
  {
    title: "ADVANCE PAYMENT TOOL",
    link: "https://automation.aosmith.in/",
    sso: "advance",
    description:
      "A single gateway for employees to access all work tools, resources, and organizational updates.",
  },
  {
    title: "AR TOOL",
    link: "https://ar.aosmith.in/",
    sso: true, // special case → uses ?vobnd & ?qbtt
    description:
      "Automates Accounts Receivable tracking, approval, and reconciliation.",
  },
  {
    title: "ALTERNATIVE PART CODE",
    link: "https://automation.aosmith.in/",
    sso: "servicealt",
    description:
      "Enables mapping and validation of alternate material or part codes for operational accuracy.",
  },
  {
    title: "DASHBOARD",
    link: "https://salesreport.aosmith.in/",
    sso: "dashboard",
    description:
      "Provides real-time insights and analytics on business performance metrics.",
  },
  {
    title: "EXPENSE PORTAL",
    link: "https://claims.aosmith.in/expense_sso.php",
    sso: true,
    description:
      "Streamlines submission and reimbursement of employee expenses.",
  },
  {
    title: "EMPLOYEE SALE",
    link: "https://automation.aosmith.in/",
    sso: "empsale",
    description: "Manages employee purchase programs.",
  },
  {
    title: "FNF WORKFLOW",
    link: "https://fnf.aosmith.in/",
    sso: true,
    description: "Automates Full and Final settlement processes.",
  },
  {
    title: "GLOBAL INTRANET",
    link: "https://aosnet.aosmith.com/Login/",
    sso: false,
    description: "Central communication and collaboration hub.",
  },
  {
    title: "HRIS PORTAL",
    link: "https://ess.pockethrms.com/",
    sso: false,
    description: "Human Resource Management System.",
  },
  {
    title: "INSTALLATION REPORT PORTAL",
    link: "https://serviceinstallation.aosmith.in/",
    sso: "installreport",
    description: "Captures service and installation reports.",
  },
  {
    title: "INVOICE CANCELLATION PORTAL",
    link: "https://cn.aosmith.in/",
    sso: "invoicecancel",
    description: "Controlled approval of cancelled invoices.",
  },
  {
    title: "JV ENTRY",
    link: "https://jv.aosmith.in/",
    sso: "jv",
    description: "Automates Journal Voucher creation workflows.",
  },
  {
    title: "LEGATRIX",
    link: "https://legatrix.aosmith.in/",
    sso: false,
    description: "Legal case & compliance tracking platform.",
  },
  {
    title: "SALES PORTAL",
    link: "https://sales.aosmith.in/",
    sso: "emailenc", // Special SSO format using email encoding
    description: "Supports sales process including leads and tracking.",
  },
  {
    title: "SRN/POD PORTAL",
    link: "https://sri.aosmith.in/",
    sso: "emailenc", // Special SSO format using email encoding
    description: "Tracks SRI and POD for logistics visibility.",
  },
  {
    title: "WEB EMAIL",
    link: "https://outlook.office.com/owa/",
    sso: false,
    description: "Secure browser-based corporate email.",
  },
  {
    title: "WORKFLOW AUTOMATION",
    link: "https://workflow.aosmith.in/user/user/validate_login",
    sso: "postform", // Special case - requires POST form submission with windows_login_id
    description: "Automates approval processes across departments.",
  },
  {
    title: "BACK GATE ENTRY",
    link: "http://10.8.242.160/gateentry/",
    sso: false,
    description: "Used to record in and out movement of goods through the back gate for tracking and verification.",
  },
  {
    title: "ELAB AUTOMATION",
    link: "https://elab.aosmith.in/",
    sso: false,
    description: "Used to manage lab activities such as testing requests, results, and approvals for engineering and product development",
  },
  {
    title: "ECR AUTOMATION",
    link: "http://ecr.aosmith.in",
    sso: false,
    description: "Used by the engineering team to raise, track, and approve change requests for company-developed products",
  },
  {
    title: "SALES INCENTIVES",
    link: "http://10.160.3.12/incentive/",
    sso: false,
    description: "Used to calculate and manage sales incentives based on performance and predefined incentive rules",
  },
  {
    title: "BAUTOMATE",
    link: "https://ai-login.bautomate.com/auth/realms/platform-realm/protocol/openid-connect/auth?client_id=platform-app&redirect_uri=https%3A%2F%2Fai-cp.bautomate.com%2F&response_type=code&scope=openid%20profile%20email&nonce=6d4016af8d1bc70b2149381c97d631d1abZqfvLad&state=ecbec34c40a9c3b3295a05eb7423b1c7997YCd4NI&code_challenge=Z7AgOE89eGx_v9Zt9h38mZcAualfZftj6DOBa9K_zbc&code_challenge_method=S256",
    sso: false,
    description: "It’s designed to help enterprises automate and streamline repetitive, manual tasks using smart software solutions",
  },
  {
    title: "ADJUSTMENT WORKFLOW",
    link: "https://sfintegration.aosmith.in/FlowSyncx/",
    sso: false,
    description: "For Stock Adjustments With Approval Workflow.",
  },
  {
    title: "TRAVEL PORTAL - GLOBE(YATRA)",
    link: "https://www.yatra.com/business",
    sso: false,
    description: "Self-booking tool for official travel and accommodation.",
  },
];
export const PUREITBD_LINKS_IN = [
  {
    title: "AR TOOL",
    link: "https://arprdpurin.aosmith.in/",
    sso: true, // special case → uses ?vobnd & ?qbtt
    description:
      "Automates Accounts Receivable tracking, approval, and reconciliation.",
  },

  {
    title: "EXPENSE PORTAL",
    link: "https://claimspureit.aosmith.in/expense_sso.php",
    sso: true,
    description:
      "Streamlines submission and reimbursement of employee expenses.",
  },
  {
    title: "EMPLOYEE SALE",
    link: "https://pureitworkflow.aosmith.in/",
    sso: "empsale",
    description: "Manages employee purchase programs.",
  },
  {
    title: "FNF WORKFLOW",
    link: "https://fnfprdpurin.aosmith.in/",
    sso: true,
    description: "Automates Full and Final settlement processes.",
  },
  {
    title: "GLOBAL INTRANET",
    link: "https://aosnet.aosmith.com",
    sso: false,
    description: "Central communication and collaboration hub.",
  },
  {
    title: "HRIS PORTAL",
    link: "https://ess.pockethrms.com/",
    sso: false,
    description: "Human Resource Management System.",
  },

  {
    title: "INVOICE CANCELLATION PORTAL",
    link: "https://invcnprdpurin.aosmith.in/",
    sso: "invoicecancel",
    description: "Controlled approval of cancelled invoices.",
  },
  {
    title: "JV ENTRY",
    link: "https://jvpureit.aosmith.in/",
    sso: "jv",
    description: "Automates Journal Voucher creation workflows.",
  },

  {
    title: "SALES PORTAL",
    link: "https://salesprdpurin.aosmith.in/",
    sso: "emailenc", // Special SSO format using email encoding
    description: "Supports sales process including leads and tracking.",
  },
  {
    title: "SRN/POD PORTAL",
    link: "https://sriprdpurin.aosmith.in/",
    sso: "emailenc", // Special SSO format using email encoding
    description: "Tracks SRI and POD for logistics visibility.",
  },
  {
    title: "WEB EMAIL",
    link: "https://outlook.office.com/owa/",
    sso: false,
    description: "Secure browser-based corporate email.",
  },
  {
    title: "WORKFLOW AUTOMATION",
    link: "https://workflow.aosmith.in/user/user/validate_login",
    sso: "postform", // Special case - requires POST form submission with windows_login_id
    description: "Automates approval processes across departments.",
  },
  {
    title: "BAUTOMATE",
    link: "https://ai-login.bautomate.com/auth/realms/platform-realm/protocol/openid-connect/auth?client_id=platform-app&redirect_uri=https%3A%2F%2Fai-cp.bautomate.com%2F&response_type=code&scope=openid%20profile%20email&nonce=6d4016af8d1bc70b2149381c97d631d1abZqfvLad&state=ecbec34c40a9c3b3295a05eb7423b1c7997YCd4NI&code_challenge=Z7AgOE89eGx_v9Zt9h38mZcAualfZftj6DOBa9K_zbc&code_challenge_method=S256",
    sso: false,
    description: "It’s designed to help enterprises automate and streamline repetitive, manual tasks using smart software solutions",
  },
  {
    title: "ADJUSTMENT WORKFLOW",
    link: "https://sfintegration.aosmith.in/FlowSyncx/",
    sso: false,
    description: "For Stock Adjustments With Approval Workflow.",
  },
  {
    title: "TRAVEL PORTAL - GLOBE(YATRA)",
    link: "https://www.yatra.com/business",
    sso: false,
    description: "Self-booking tool for official travel and accommodation.",
  },
  {
    title: "DASHBOARD",
    link: "https://srprdpurin.aosmith.in/",
    sso: "dashboard",
    description:
      "Provides real-time insights and analytics on business performance metrics.",
  },
  {
    title: "ADVANCE PAYMENT TOOL",
    link: "https://pureitworkflow.aosmith.in/",
    sso: "advance",
    description:
      "A single gateway for employees to access all work tools, resources, and organizational updates.",
  },
  {
    title: "INSTALLATION REPORT PORTAL",
    link: "https://pureitprdsr.aosmith.in//",
    sso: "installreport",
    description: "Captures service and installation reports.",
  },
];

export const PUREITBD_LINKS_BN = [
  {
    title: "AR TOOL",
    link: "https://arprdpurbd.aosmith.in/",
    sso: true, // special case → uses ?vobnd & ?qbtt
    description:
      "Automates Accounts Receivable tracking, approval, and reconciliation.",
  },

  {
    title: "EXPENSE PORTAL",
    link: "https://claimspureitbd.aosmith.in/expense_sso.php",
    sso: true,
    description:
      "Streamlines submission and reimbursement of employee expenses.",
  },
 
  {
    title: "GLOBAL INTRANET",
    link: "https://aosnet.aosmith.com/",
    sso: false,
    description: "Central communication and collaboration hub.",
  },


  {
    title: "INVOICE CANCELLATION PORTAL",
    link: "https://invcnprdpurbd.aosmith.in/",
    sso: "invoicecancel",
    description: "Controlled approval of cancelled invoices.",
  },
  {
    title: "JV ENTRY",
    link: "https://jvbangla.aosmith.in/",
    sso: "jv",
    description: "Automates Journal Voucher creation workflows.",
  },

  {
    title: "SALES PORTAL",
    link: "https://salesprdpurbd.aosmith.in/",
    sso: "emailenc", // Special SSO format using email encoding
    description: "Supports sales process including leads and tracking.",
  },
  {
    title: "SRN/POD PORTAL",
    link: "https://sriprdpurbd.aosmith.in/",
    sso: "emailenc", // Special SSO format using email encoding
    description: "Tracks SRI and POD for logistics visibility.",
  },
  {
    title: "WEB EMAIL",
    link: "https://outlook.office.com/owa/",
    sso: false,
    description: "Secure browser-based corporate email.",
  },
  {
    title: "WORKFLOW AUTOMATION",
    link: "https://workflow.aosmith.in/user/user/validate_login",
    sso: "postform", // Special case - requires POST form submission with windows_login_id
    description: "Automates approval processes across departments.",
  },
  {
    title: "ADVANCE PAYMENT TOOL",
    link: "https://pureitworkflowbd.aosmith.in/",
    sso: "advance",
    description:
      "A single gateway for employees to access all work tools, resources, and organizational updates.",
  },
];
export const PUREITBD_LINKS_SR = [
   {
    title: "EXPENSE PORTAL",
    link: "https://claimspureitsl.aosmith.in/expense_sso.php",
    sso: true,
    description:
      "Streamlines submission and reimbursement of employee expenses.",
  },
  
  {
    title: "JV ENTRY",
    link: "https://jvsrilanka.aosmith.in/",
    sso: "jv",
    description: "Automates Journal Voucher creation workflows.",
  }
];

// src/utils/normalizePath.js
// src/utils/normalizePath.js
export function normalizePath(path) {
  if (typeof path !== "string" || path.trim() === "") {
    return "/"; // default fallback
  }
  const parts = path.split("://");
  if (parts.length === 2) {
    const [protocol, rest] = parts;
    return `${protocol}://${rest.replace(/\/{2,}/g, "/")}`;
  }
  return path.replace(/\/{2,}/g, "/");
}

// Function to get appropriate links based on company selection
export function getLinksByCompany(company: string) {
  let links;

  switch (company) {
    case "aosmith-india":
    case "aosmith":
      links = AOSMITH_LINKS;
      break;

    case "pureit-india":
      links = PUREITBD_LINKS_IN;
      break;

    case "pureit-bangladesh":
      links = PUREITBD_LINKS_BN;
      break;

    case "pureit-srilanka":
      links = PUREITBD_LINKS_SR;
      break;

    case "aosmith-bangladesh":
    case "aosmith-srilanka":
    default:
      links = AOSMITH_LINKS;
      break;
  }

  // ✅ safe copy + sort
  return [...links].sort((a, b) =>
    a?.title?.localeCompare(b.title)
  );
}
